import React, { useEffect, useState } from "react";
import {
  AddButton,
  CancelButton,
  SubmitButton,
  UpdateButton,
} from "../../components/mui/Buttons/Buttons";
import { Form, FormikProvider, useFormik } from "formik";
import { Autocomplete, Box, Stack, TextField } from "@mui/material";
import GlobalDialog from "../../components/mui/Dialogue/GlobalDialog";
import GlobalSelectField from "../../components/mui/GlobalSelectField";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import {
  addPermissionRelation,
  getUsersUnderDepartment,
} from "../../redux/features/permissionSlice";

const Permissionrelation = ({ department, permission }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading, usersunderdpt } = useSelector((state) => state.permission);

  const [selectedUsers, setSelectedUsers] = useState([]);

  const ValidationSchema = Yup.object().shape({
    userType: Yup.array()
      .of(Yup.number())
      .min(1, "Please select at least one user")
      .required("Please select users"),
  });

  const formik = useFormik({
    enableReinitialize: true,

    initialValues: {
      permissionId: permission,
      userType: [],
    },
    validationSchema: ValidationSchema,
    onSubmit: (values) => {
      dispatch(addPermissionRelation(values)).then((res) => {
        console.log(res);
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          formik.resetForm();
          setOpen(false);
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
          // setOpen(false);
        }
      });
    },
  });

  useEffect(() => {
    dispatch(getUsersUnderDepartment(department));
  }, [department]);

  const handleusertype = (e, selectedOptions) => {
    const uniqueUsers = Array.from(
      new Map(selectedOptions.map((user) => [user.userID, user])).values()
    );

    setSelectedUsers(uniqueUsers);

    const typeIDs = uniqueUsers.map((user) => user.usertypeID);
    formik.setFieldValue("userType", typeIDs);
  };

  return (
    <GlobalDialog
      title={"Permission Relation"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"md"}
      closeButton={true}
      popupButton={
        <AddButton size="medium" action={() => setOpen(true)}>
          Permission Relation
        </AddButton>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={2}>
                  <Autocomplete
                    fullWidth
                    multiple
                    name="userType"
                    options={usersunderdpt}
                    getOptionLabel={(option) => option.name || ""}
                    value={selectedUsers}
                    onChange={handleusertype}
                    renderInput={(params) => (
                      <TextField
                        disabled
                        fullWidth
                        autoComplete="off"
                        {...params}
                        label="User"
                        error={
                          formik.touched.userType &&
                          Boolean(formik.errors.userType)
                        }
                        helperText={
                          formik.touched.userType && formik.errors.userType
                        }
                      />
                    )}
                  />
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <CancelButton size="small" action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    <SubmitButton disabled={loading} size="small" type="submit">
                      {loading ? "Please wait..." : "Save"}
                    </SubmitButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default Permissionrelation;
